import { makeActionCreator } from '../../../utilities'
import { ClientDataConstants } from './clientData.constants'

export const setClientData = makeActionCreator(ClientDataConstants.SET_CLIENT_DATA)
export const setClientDataError = makeActionCreator(
  ClientDataConstants.SET_CLIENT_DATA_IMPORT_ERROR,
  'clientDataImportError'
)
export const onClientDataImportSuccess = makeActionCreator(ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS)
